import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, take, filter, combineLatest } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);


  canActivate(): Observable<boolean> {
    return combineLatest([
      this.authService.currentUser$,
      this.authService.isLoading$
    ]).pipe(
      filter(([_user, isLoading]) => !isLoading), // Wait until loading is complete
      take(1),
      map(([user]) => {
        if (user) {
          this.router.navigate(['/dashboard']);
          return false;
        }
        return true;
      })
    );
  }
}